/**
 * Library usage hook — the one-query rollup feeding every ask-on-edit and
 * delete prompt. Server-truth only (30s stale, refetched before fork asks).
 * For Media Devoted | Created By Ciro Autiero
 */

import { useQuery } from '@tanstack/react-query';

import { getLibraryUsage } from '../client/packages-api';
import { libraryKeys } from '../keys';

export function useLibraryUsage(enabled = true) {
  return useQuery({
    queryKey: libraryKeys.usage(),
    queryFn: getLibraryUsage,
    enabled,
    staleTime: 30_000,
  });
}
